import { useContext } from 'react';
import { ConsentContext } from './ConsentContext';

export const useConsent = () => useContext(ConsentContext);
